import script from "./UserGroupDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserGroupDialog.vue?vue&type=script&lang=ts&setup=true"

import "./UserGroupDialog.vue?vue&type=style&index=0&id=1b2070b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2070b2"]])

export default __exports__